import React, { FC, lazy, useEffect } from 'react'
import { Switch, useHistory } from 'react-router-dom'
import { FrontUrls } from 'Constants/FrontUrls'
import { LazyRoute, filtersSlice } from 'Modules'
import { useAppDispatch } from 'Src/hooks'
import { useUnmount } from 'Src/hooks/useUnmount'
import { useSelector } from 'react-redux'
import { orderSelectors } from 'Pages/orders_design'
import { socketSlice, SocketChannel } from 'Modules/Socket'

const MobileOrdersListLazy = lazy(
	() => import('Pages/orders_design/components/mobile_orders/OrderList/index')
)

const MobileOrdersFiltersLazy = lazy(
	() => import('Pages/orders_design/components/mobile_orders/OrderList/Filters/index')
)
const MobileOrdersReportLazy = lazy(
	() => import('Pages/orders_design/components/mobile_orders/OrderList/UnloadReport/index')
)
const MobileOrderViewLazy = lazy(
	() => import('Pages/orders_design/components/mobile_orders/OrderList/OrderView/index')
)

const MobileOrderCreateLazy = lazy(
	() => import('Pages/orders_design/components/mobile_orders/OrderCreate/MobileOrdersInn')
)

const MobileReceivingAgreementLazy = lazy(
	() => import('Pages/orders_design/components/mobile_orders/OrderCreate/MobileReceivingAgreement')
)

const MobileOrdersAgreementLazy = lazy(
	() => import('Pages/orders_design/components/mobile_orders/OrderCreate/MobileAgreement')
)

const MobileOrderProductsLazy = lazy(
	() => import('Pages/orders_design/components/mobile_orders/OrderCreate/MobileOrdersProducts')
)

const MobileOrderCartLazy = lazy(
	() => import('Pages/orders_design/components/mobile_orders/OrderCreate/MobileProductsCart')
)

const MobileOrderFormLazy = lazy(
	() => import('Pages/orders_design/components/mobile_orders/OrderCreate/MobileOrderForm')
)

const MobileOrderFinalStepLazy = lazy(
	() => import('Pages/orders_design/components/mobile_orders/OrderCreate/MobileOrdersFinalStep')
)

const MobileOrderReserveLazy = lazy(
	() => import('Pages/orders_design/components/mobile_orders/OrderCreate/MobileOrderReserve')
)

const actions = {
	clearFilters: filtersSlice.actions.clearFilters,
	subscribeChannels: socketSlice.actions.subscribeChannels,
	unSubscribeChannels: socketSlice.actions.unSubscribeChannels,
}

export const MobileOrdersRouter: FC = () => {
	const { clearFilters, subscribeChannels, unSubscribeChannels } = useAppDispatch(actions)
	const history = useHistory()
	const orderInn = useSelector(orderSelectors.getClientINN)
	useUnmount(() => {
		clearFilters()
	})

	useEffect(() => {
		subscribeChannels([SocketChannel.RESERVE_ACCOUNT_CHANNEL, SocketChannel.LEAD_CHANNEL])
		return () => {
			unSubscribeChannels([SocketChannel.RESERVE_ACCOUNT_CHANNEL, SocketChannel.LEAD_CHANNEL])
		}
	}, [])

	useEffect(() => {
		if (orderInn === undefined && window.location.href.indexOf('create') > -1) {
			history.push(FrontUrls.orders_redesign_mobile.check_inn)
		}
	}, [])

	return (
		<Switch>
			<LazyRoute
				exact
				path={FrontUrls.orders_redesign_mobile.reserve}
				lazyComponent={MobileOrderReserveLazy}
			/>
			<LazyRoute
				exact
				path={FrontUrls.orders_redesign_mobile.created}
				lazyComponent={MobileOrderFinalStepLazy}
			/>
			<LazyRoute
				exact
				path={FrontUrls.orders_redesign_mobile.form}
				lazyComponent={MobileOrderFormLazy}
			/>
			<LazyRoute
				exact
				path={FrontUrls.orders_redesign_mobile.cart}
				lazyComponent={MobileOrderCartLazy}
			/>
			<LazyRoute
				exact
				path={FrontUrls.orders_redesign_mobile.product}
				lazyComponent={MobileOrderProductsLazy}
			/>
			<LazyRoute
				exact
				path={FrontUrls.orders_redesign_mobile.completed}
				lazyComponent={MobileOrdersAgreementLazy}
			/>
			<LazyRoute
				exact
				path={FrontUrls.orders_redesign_mobile.agreement}
				lazyComponent={MobileReceivingAgreementLazy}
			/>
			<LazyRoute
				exact
				path={FrontUrls.orders_redesign_mobile.check_inn}
				lazyComponent={MobileOrderCreateLazy}
			/>
			<LazyRoute
				exact
				path={FrontUrls.orders_redesign_mobile.view}
				lazyComponent={MobileOrderViewLazy}
			/>
			<LazyRoute
				exact
				path={FrontUrls.orders_redesign_mobile.report}
				lazyComponent={MobileOrdersReportLazy}
			/>
			<LazyRoute
				exact
				path={FrontUrls.orders_redesign_mobile.filters}
				lazyComponent={MobileOrdersFiltersLazy}
			/>
			<LazyRoute
				exact
				path={FrontUrls.orders_redesign.index}
				lazyComponent={MobileOrdersListLazy}
			/>
		</Switch>
	)
}
